export const stringRegexReplace = (str: string, regex: RegExp): string => {
  return str.replace(regex, ' ').trim()
}
